import httpClient from "@/API/HttpClient";


// Menu
const getstorebyslug = (shop,lanid) => httpClient.get(`StoreProfile/${shop}`,{headers:{language:lanid}});
const getMenu = (shop,id,lanid) => httpClient.get(`${shop}/Menu/${id}`,{headers:{language:lanid}});
const getMenuN1 = (shop,id,lanid) => httpClient.get(`${shop}/MenuN1/${id}`,{headers:{language:lanid}});
const getDigitalMenu = (shop,id,lanid) => httpClient.get(`${shop}/DigitalMenu/${id}`,{headers:{language:lanid}});
const getCatMenu = (shop,id,idd,lanid) => httpClient.get(`${shop}/Menu/${id}?catid=${idd}`,{headers:{language:lanid}});
const getSubMenu = (shop,id,idd,submenu,lanid) => httpClient.get(`${shop}/Menu/${id}?catid=${idd}&submenu=${submenu}`,{headers:{language:lanid}});
const getLanguages = (shop) => httpClient.get(`language/${shop}`)
const getLastAnnouncement = (shop,announcementdisplaymode) => httpClient.get(`Announcement/${shop}/last?announcementDisplayMode=${announcementdisplaymode}`)
const getAllLanguages = () => httpClient.get(`language`)
const getLanguagesbymenu = (shop,menuid) => httpClient.get(`language/${shop}/${menuid}`)
const GetStoreBySlug = (slug) => httpClient.get(`Store/${slug}`);
export {
    getstorebyslug,
    getMenu,
    getMenuN1,
    getCatMenu,
    getSubMenu,
    getLanguages,
    getLanguagesbymenu,
    getDigitalMenu,
    getAllLanguages,
    GetStoreBySlug,
    getLastAnnouncement
 }
